module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_editor') === -1 && _vm.$route.path.indexOf('_team') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addGroups
    }
  }, [_vm._v("新增拼团活动")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "first"
    }
  }, [_c('groupsList', {
    ref: "groupsList",
    attrs: {
      "view": 0
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "未开始",
      "name": "second"
    }
  }, [_c('groupsList', {
    attrs: {
      "view": 1
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "进行中",
      "name": "third"
    }
  }, [_c('groupsList', {
    attrs: {
      "view": 2
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已结束",
      "name": "fourth"
    }
  }, [_c('groupsList', {
    attrs: {
      "view": 3
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-606b28c9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606b28c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/groups/index.vue
// module id = 2762
// module chunks = 0